import { Component, EventEmitter, Input, Output, effect } from '@angular/core';
import { IAuthMenu, RequestMenu } from '../../models';
import { Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AuthorizationService } from '../../services';
import { MenuHorizontalComponent } from '../';

@Component({
  selector: 'app-horizontal-menu-and-content',
  standalone: true,
  imports: [MenuHorizontalComponent],
  templateUrl: './horizontal-menu-and-content.component.html',
  styleUrl: './horizontal-menu-and-content.component.scss'
})
export class HorizontalMenuAndContentComponent {

  /*-------------------------- input parameters ------------*/

  @Input() applicationId: string | null = null;
  @Input() hierarchyId: string | null = null;
  @Input() hierarchyCode: string = "horizontal";
  @Input() impersonationEmail: string | null = null;
  @Input() title: string | null = null;
  @Input() area: string | null = null;

  @Output() onMenuLoadComplete = new EventEmitter<IAuthMenu[]>();
  @Output() onMenuExportClicked = new EventEmitter<string>();

  //----------------- data properties  ------------------

  menuItems!: IAuthMenu[];
  selected!: IAuthMenu;

  //----------------- State properties  ------------------

  protected destroy$ = new Subject();
  protected prevImpersonationEmail?: string | null;


  //----------------- Constructor  ------------------
  constructor(private router: Router
    , private authService: AuthorizationService) {

    effect(() => {
      const currentValue = this.impersonationEmail;

      if (currentValue !== this.prevImpersonationEmail) {
        this.prevImpersonationEmail = currentValue;
        this.refreshMenu();
      }
    });

  }

  ngOnInit() {

    // if title is there, then this will be passed on to menu-horizontal component. Nothing else to be done
    if (this.title && this.title != '') {
      let menuItem = {} as IAuthMenu;
      menuItem.name = this.title;
      this.menuItems.push(menuItem);
    }
    else if (this.hierarchyId && this.hierarchyId != '' && this.hierarchyId.length == 36) {
      this.router.events
        .pipe(takeUntil(this.destroy$))
        .subscribe(event => {
          if (event instanceof NavigationEnd) {

            this.refreshSelection(this.menuItems, event.url);
          }
        }
        );
    }
  }

  //----------------- Public methods ------------------------

  /**
   * Refresh the menu items from the server updating the cache
   */
  public refreshMenu(): void {
    this.fetchServerData();
  }

  //----------------- Control processing   ------------------

  protected updateMenuItems(data: IAuthMenu[], emitEvent: boolean = true): void {
    this.refreshSelection(data, this.router.url);
    this.menuItems = data;

    if (emitEvent)
      this.onMenuLoadComplete.emit(data);
  }

  refreshSelection(items: IAuthMenu[], newUrl: string): boolean {

    if (!items)
      return false;

    let anySelected = false;

    for (let item of items) {

      if (item.hasChildren && item.children) {
        item.selected = this.refreshSelection(item.children, newUrl);
      }
      else {
        item.selected = !!(item.url && newUrl && newUrl.toUpperCase().includes(item.url.toUpperCase()));
      }

      if (item.selected)
        anySelected = true;
    }

    return anySelected;
  }

  onExportClicked(exportType: string) {
    this.onMenuExportClicked.emit(exportType);
  }

  //----------------- api processing   ------------------

  protected fetchServerData(): void {
    const req: RequestMenu = new RequestMenu();
    req.hierarchyCode = this.hierarchyCode;
    this.updateMenuItems([], false);

    if (this.applicationId != null) {
      req.applicationId = this.applicationId;
    }

    if (this.hierarchyId != null) {
      req.hierarchyId = this.hierarchyId;

      if (this.area != undefined && this.area != null && this.area != "")
        this.authService.menuGet$(req, this.area)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (data: IAuthMenu[]) => {
              this.updateMenuItems(data);

              // Store the retrieved data in local storage for future use
              //localStorage.setItem('menuData', JSON.stringify(data));
            }
          );
      else
        this.authService.menuGet$(req)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (data: IAuthMenu[]) => {
              this.updateMenuItems(data);

              // Store the retrieved data in local storage for future use
              //localStorage.setItem('menuData', JSON.stringify(data));
            }
          );
    }
  }
}
